import React, { Component } from 'react';
import { Row, Col, Card } from 'reactstrap';

//import {Stats, BigBreadcrumbs, WidgetGrid, JarvisWidget}  from '../../../components';

import ChartJsGraph from './chartjs/ChartJsGraph';

const chartjson = require('./chartjs/chartjs.json');

class Profile extends Component {

  state = chartjson;

  componentWillMount() {
	//request('GET', './chartjs/chartjs.json', { json: true }).done((res) => {
	//  this.setState(JSON.parse(res.getBody()));
	//});
  }

  renderArticles() {
		return;
	return (
		<div className="row">
	        <div className="col-sm-12" >
	          <hr />
	          <div className="padding-10">
	            <ul className="nav nav-tabs tabs-pull-right">
	              <li className="active">
	                <a href="#a1" data-toggle="tab">Recent Articles</a>
	              </li>
	              <li>
	                <a href="#a2" data-toggle="tab">New Members</a>
	              </li>
	              <li className="pull-left">
	                <span className="margin-top-10 display-inline"><i
	                    className="fa fa-rss text-success"></i> Activity</span>
	              </li>
	            </ul>
	            <div className="tab-content padding-top-10">
	              <div className="tab-pane fade in active" id="a1">
	                <div className="row">
	                  <div className="col-xs-2 clo-sm-1" >
	                    <time dateTime="2014-09-20" className="icon">
	                      <strong>Jan</strong>
	                      <span>10</span>
	                    </time>
	                  </div>
	                  <div className="col-xs-10 col-sm-11" >
	                    <h6 className="no-margin"><a href="#">Allice in Wonderland</a></h6>
	                    <p>
	                      Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi Nam eget dui.
	                      Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero,
	                      sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel.
	                    </p>
	                  </div>
	                  <div className="col-sm-12" >
	                    <hr />
	                  </div>
	                  <div className="col-xs-2 col-sm-1" >
	                    <time dateTime="2014-09-20" className="icon">
	                      <strong>Jan</strong>
	                      <span>10</span>
	                    </time>
	                  </div>
	                  <div className="col-xs-10 col-sm-11" >
	                    <h6 className="no-margin"><a href="#">World Report</a></h6>
	                    <p>
	                      Morning our be dry. Life also third land after first beginning to evening cattle created
	                      let subdue you'll winged don't Face firmament.
	                      You winged you're was Fruit divided signs lights i living cattle yielding over light
	                      life life sea, so deep.
	                      Abundantly given years br /ing were after. Greater you're meat beast creeping behold he
	                      unto She'd doesn't. Replenish br /ought kind gathering Meat.
	                    </p>
	                  </div>
	                  <Col sm="12" >
	                    <br />
	                  </Col>
	                </div>
	              </div>
	              <div className="tab-pane fade" id="a2">
	                <div className="alert alert-info fade in">
	                  <button className="close" data-dismiss="alert">
	                    &#xD7;
	                  </button>
	                  <i className="fa-fw fa fa-info"></i>
	                  <strong>51 new members </strong>joined today!
	                </div>
	                <div className="user" title="email@company.com">
	                  <img src={require('../../assets/images/avatars/female.png')} alt="demo user" /><a href="#">Jenn Wilson</a>
	                   <div className="email">
	                    travis@company.com
	                  </div>
	                </div>
	                <div className="user" title="email@company.com">
	                  <img src={require('../../assets/images/avatars/male.png')} alt="demo user" /><a href="#">Marshall Hitt</a>
	                   <div className="email">
	                    marshall@company.com
	                  </div>
	                </div>
	                <div className="user" title="email@company.com">
	                  <img src={require('../../assets/images/avatars/male.png')} alt="demo user" /><a href="#">Joe Cadena</a>
	                   <div className="email">
	                    joe@company.com
	                  </div>
	                </div>
	                <div className="user" title="email@company.com">
	                  <img src={require('../../assets/images/avatars/male.png')} alt="demo user" /><a href="#">Mike Mcbr /ide</a>
	                   <div className="email">
	                    mike@company.com
	                  </div>
	                </div>
	                <div className="user" title="email@company.com">
	                  <img src={require('../../assets/images/avatars/male.png')} alt="demo user" /><a href="#">Travis Wilson</a>
	                   <div className="email">
	                    travis@company.com
	                  </div>
	                </div>
	                <div className="user" title="email@company.com">
	                  <img src={require('../../assets/images/avatars/male.png')} alt="demo user" /><a href="#">Marshall Hitt</a>
	                   <div className="email">
	                    marshall@company.com
	                  </div>
	                </div>
	                <div className="user" title="Joe Cadena joe@company.com">
	                  <img src={require('../../assets/images/avatars/male.png')} alt="demo user" /><a href="#">Joe Cadena</a>
	                   <div className="email">
	                    joe@company.com
	                  </div>
	                </div>
	                <div className="user" title="email@company.com">
	                  <img src={require('../../assets/images/avatars/male.png')} alt="demo user" /><a href="#">Mike Mcbr /ide</a>
	                   <div className="email">
	                    mike@company.com
	                  </div>
	                </div>
	                <div className="user" title="email@company.com">
	                  <img src={require('../../assets/images/avatars/male.png')} alt="demo user" /><a href="#">Marshall Hitt</a>
	                   <div className="email">
	                    marshall@company.com
	                  </div>
	                </div>
	                <div className="user" title="email@company.com">
	                  <img src={require('../../assets/images/avatars/male.png')} alt="demo user" /><a href="#">Joe Cadena</a>
	                   <div className="email">
	                    joe@company.com
	                  </div>
	                </div>
	                <div className="user" title="email@company.com">
	                  <img src={require('../../assets/images/avatars/male.png')} alt="demo user" /><a href="#"> Mike McBride</a>
	                   <div className="email">
	                    mike@company.com
	                  </div>
	                </div>
	                <div className="text-center">
	                  <ul className="pagination pagination-sm">
	                    <li className="disabled">
	                      <a href="#">Prev</a>
	                    </li>
	                    <li className="active">
	                      <a href="#">1</a>
	                    </li>
	                    <li>
	                      <a href="#">2</a>
	                    </li>
	                    <li>
	                      <a href="#">3</a>
	                    </li>
	                    <li>
	                      <a href="#">...</a>
	                    </li>
	                    <li>
	                      <a href="#">99</a>
	                    </li>
	                    <li>
	                      <a href="#">Next</a>
	                    </li>
	                  </ul>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </div>
		);
	}

	renderBio() {
		return;
		return (
	<div>
	<br />
	 <h1> About Yadho... </h1>
	<p>
	 Believing I am the best thing since government subsidized Tunisian sliced br / ed, I can to the US of A to commandeer the financial world.I recently left my high paying investment banking job to disrupt the industry with my leader, the illustrious Jean - Marc Arsan. </p>
	<br />
			</div>

		);
	}
  render() {
	return (

	<div className="row">
	  <div className="col-sm-12 col-md-12 col-lg-12" id="profiledetails" >
	    <div className="well well-light well-sm no-margin no-padding">
	      <div className="row">
	        <div className="col-sm-12" >
	          <div id="myCarousel" className="carousel fade profile-carousel">
	            <div className="air air-bottom-right padding-10">
	              <a href="#" className="btn txt-color-white bg-color-teal btn-sm"><i className="fa fa-check"></i>
	                Follow</a>&#xA0;
	              <a href="#" className="btn txt-color-white bg-color-pinkDark btn-sm"><i className="fa fa-link"></i>
	                Connect</a>
	            </div>
	            <ol className="carousel-indicators">
	              <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
	              <li data-target="#myCarousel" data-slide-to="1" className></li>
	              <li data-target="#myCarousel" data-slide-to="2" className></li>
	            </ol>
	            <div className="carousel-inner">
	              <div className="item active">
	                <img src={require('../../assets/images/carousel/sfax.jpg')} alt="demo user" />
	              </div>
	              <div className="item">
	                <img src={require('../../assets/images/carousel/camel.jpg')} alt="demo user" />
	              </div>
	              <div className="item">
	                <img src={require('../../assets/images/carousel/popsy.png')} alt="demo user" />
	              </div>
	            </div>
	          </div>
	        </div>
	        <div className="col-sm-12" >
	          <div className="row">
	            <div className="col-sm-3  profile-pic" >
	              <img src={require('../../assets/images/avatars/yadho.png')} alt="demo user" />
	               <div className="padding-10">
	                <h4 className="font-md"><strong>1,543</strong>
	                  <br />
	                  <small>Followers</small>
	                </h4>
	                <br />
	                <h4 className="font-md"><strong>419</strong>
	                  <br />
	                  <small>Connections</small>
	                </h4>
	              </div>
	            </div>
	            <div className="col-sm-16" >
	              <h1>Ya <span className="semi-bold">Dho</span>
	                <br />
	                <small> CAO, p2pvest.io</small>
	              </h1>
	              <ul className="list-unstyled">
	                <li>
	                  <p className="text-muted">
	                    <i className="fa fa-phone"></i>&#xA0;&#xA0;(<span className="txt-color-darken">313</span>) <span
	                      className="txt-color-darken">464</span> - <span className="txt-color-darken">6473</span>
	                  </p>
	                </li>
	                <li>
	                  <p className="text-muted">
	                    <i className="fa fa-envelope"></i>&#xA0;&#xA0;<a href="mailto:simmons@smartadmin">cao@p2pvest.com</a>
	                  </p>
	                </li>
	                <li>
	                  <p className="text-muted">
	                    <i className="fa fa-skype"></i>&#xA0;&#xA0;<span className="txt-color-darken">tunisiansweetness</span>
	                  </p>
	                </li>
	              </ul>
	              {this.renderBio()}
	              <h1>Investments</h1>
	              <ul className="list-inline">
	                <li>
	                  <div className="well" style={{ padding: '5px' }}>
	                    <img src={require('../../assets/images/companies/fundrise.png')} alt="fundrise"/>
	                    <h4 className="font-sm">Fundrise</h4>
	                  </div>
	                </li>
	                <li>
	                  <div className="well" style={{ padding: '5px' }}>
	                    <img src={require('../../assets/images/companies/popsy.png')} alt="popsy"/>
	                    <h4 className="font-sm">Popsy</h4>
	                  </div>
	                </li>
	              </ul>
	              <h1>Portfolio</h1>
	              <div className="widget-body">
	                <ChartJsGraph type="doughnut" data={this.state['doughnut-chart']}/>
	              </div>
	              <br />
	              <a href="#" className="btn btn-default btn-xs"><i className="fa fa-envelope-o"></i> Send Message</a>
	            </div>
	            <div className="col-sm-3">
	              <h1>
	                <small>Connections</small>
	              </h1>
	              <ul className="list-inline friends-list">
	                <li><img src={require('../../assets/images/avatars/1.png')} alt="friend-1" />
	                </li>
	                <li><img src={require('../../assets/images/avatars/2.png')} alt="friend-2" />
	                </li>
	                <li><img src={require('../../assets/images/avatars/3.png')} alt="friend-3" />
	                </li>
	                <li><img src={require('../../assets/images/avatars/4.png')} alt="friend-4" />
	                </li>
	                <li><img src={require('../../assets/images/avatars/5.png')} alt="friend-5" />
	                </li>
	                <li><img src={require('../../assets/images/avatars/male.png')} alt="friend-6" />
	                </li>
	                <li>
	                  <a href="#">413 more</a>
	                </li>
	              </ul>
	              <h1>
	                <small>Recent visitors</small>
	              </h1>
	              <ul className="list-inline friends-list">
	                <li><img src={require('../../assets/images/avatars/male.png')} alt="friend-1" />
	                </li>
	                <li><img src={require('../../assets/images/avatars/female.png')} alt="friend-2" />
	                </li>
	                <li><img src={require('../../assets/images/avatars/female.png')} alt="friend-3" />
	                </li>
	              </ul>
	            </div>
	          </div>
	        </div>
	      </div>
	      {this.renderArticles()}
	    </div>
	  </div>
	</div>
		);
	}

}

export { Profile };



/** WEBPACK FOOTER **
 ** ./src/common/Profile.js
 **/